export default "__VITE_ASSET__5cc68130__"